import styled from 'styled-components';
import {Caption} from '../primitives/caption';
import {grey} from '../primitives/color';

export const InputHelpText = styled(Caption)`
  display: block;
  margin-top: 2px;
  color: ${grey.grey400};
`;

InputHelpText.displayName = 'InputLabel';

